/* AMTENDENCY — scroll infinito da coleção.

   A referência baixa o documento HTML inteiro de `?page=N`. Aqui usamos a
   Section Rendering API (`?page=N&section_id=…`), que devolve só a seção da
   grade — mesma sensação, uma fração do peso. O padrão é o mesmo do
   quick-order-list.js:186; o observer segue o do ProductRecommendations
   (global.js:1206).

   Contrato com o resto do tema: depois de anexar cards novos é obrigatório
   emitir `am:grid-render`, que é o sinal que am-favoritos.js escuta para
   repintar os corações e reaplicar a densidade escolhida. */
(function () {
  var estado = { bloco: null, obs: null, carregando: false };

  function grade() {
    return document.getElementById('product-grid');
  }

  /* `?page=2` → `?page=2&section_id=<id da seção>` */
  function urlDaSecao(href) {
    var g = grade();
    if (!g || !g.dataset.id) return null;
    var u = new URL(href, window.location.origin);
    u.searchParams.set('section_id', g.dataset.id);
    return u.toString();
  }

  /* Os números vêm prontos do servidor: a página N já renderiza "1 até N ×
     tamanho" e a porcentagem certa. Copiamos em vez de recalcular — só assim
     o texto continua traduzido e o arredondamento continua sendo o mesmo. */
  function atualizaBloco(novo) {
    var bloco = estado.bloco;

    var contaNova = novo.querySelector('[data-am-conta]');
    var conta = bloco.querySelector('[data-am-conta]');
    if (contaNova && conta) conta.textContent = contaNova.textContent.trim();

    var barraNova = novo.querySelector('[data-am-barra]');
    var barra = bloco.querySelector('[data-am-barra]');
    // muda só a variável: o elemento continua o mesmo e a transição de 1s roda
    if (barraNova && barra) barra.style.setProperty('--am-pct', barraNova.style.getPropertyValue('--am-pct'));

    if (novo.dataset.amCarregados) bloco.dataset.amCarregados = novo.dataset.amCarregados;

    var maisNovo = novo.querySelector('[data-am-mais]');
    var mais = bloco.querySelector('[data-am-mais]');
    if (maisNovo && mais) {
      mais.setAttribute('href', maisNovo.getAttribute('href'));
      return true;
    }
    // acabou: sai o botão, morre o observer
    if (mais) mais.remove();
    if (estado.obs) { estado.obs.disconnect(); estado.obs = null; }
    return false;
  }

  function anexaCards(doc) {
    var gradeNova = doc.getElementById('product-grid');
    var g = grade();
    if (!gradeNova || !g) return 0;
    var frag = document.createDocumentFragment();
    var n = 0;
    while (gradeNova.firstElementChild) {
      var li = gradeNova.firstElementChild;
      // as páginas seguintes nascem sempre fora da tela
      var imgs = li.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('loading', 'lazy');
      frag.appendChild(li);
      n++;
    }
    g.appendChild(frag);
    return n;
  }

  function carrega() {
    if (estado.carregando || !estado.bloco) return;
    var mais = estado.bloco.querySelector('[data-am-mais]');
    if (!mais) return;
    var url = urlDaSecao(mais.getAttribute('href'));
    if (!url) return;

    estado.carregando = true;
    estado.bloco.setAttribute('data-am-ocupado', 'true');
    mais.setAttribute('aria-busy', 'true');
    // enquanto busca, o observer não pode disparar de novo
    if (estado.obs) estado.obs.unobserve(estado.bloco);

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (texto) {
        var doc = new DOMParser().parseFromString(texto, 'text/html');
        var novo = doc.querySelector('[data-am-paginacao]');
        var quantos = anexaCards(doc);
        var temMais = novo ? atualizaBloco(novo) : false;

        estado.carregando = false;
        estado.bloco.removeAttribute('data-am-ocupado');
        if (temMais && estado.obs) estado.obs.observe(estado.bloco);

        // por último: este evento chama `inicia()` de volta, e ele reescreve
        // o estado acima. Emitir antes deixaria o observer no ar.
        if (quantos) document.dispatchEvent(new CustomEvent('am:grid-render'));
      })
      .catch(function (e) {
        // devolve o botão ao estado clicável — o href ainda leva à página certa
        console.warn('[am-paginacao]', e);
        estado.carregando = false;
        estado.bloco.removeAttribute('data-am-ocupado');
        var b = estado.bloco.querySelector('[data-am-mais]');
        if (b) b.removeAttribute('aria-busy');
        if (estado.obs) estado.obs.observe(estado.bloco);
      });
  }

  function inicia() {
    if (estado.obs) { estado.obs.disconnect(); estado.obs = null; }
    estado.carregando = false;

    var bloco = document.querySelector('[data-am-paginacao]');
    estado.bloco = bloco;
    if (!bloco || !bloco.querySelector('[data-am-mais]')) return;

    // carrega ao chegar a 600px do fim, como o ProductRecommendations do tema
    estado.obs = new IntersectionObserver(
      function (entradas) {
        if (entradas[0] && entradas[0].isIntersecting) carrega();
      },
      { rootMargin: '0px 0px 600px 0px' }
    );
    estado.obs.observe(bloco);
  }

  // o clique no botão faz o mesmo caminho, sem navegar
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-am-mais]');
    if (!b) return;
    e.preventDefault();
    carrega();
  });

  // o facets.js troca o innerHTML de #ProductGridContainer inteiro ao filtrar
  // ou ordenar, e o bloco de paginação vive lá dentro: reata no elemento novo.
  document.addEventListener('am:grid-render', inicia);
  document.addEventListener('DOMContentLoaded', inicia);
  if (document.readyState !== 'loading') inicia();
})();
